import React from "react";
// reactstrap components
import {
    Modal,
    ModalHeader,
    ModalBody
} from "reactstrap";
import "./Styles/BaseModal.css"

const BaseModal = ({ size, isOpen, toggle, headerContent, bodyContent, headerClassName, bodyClassName }) => {
    //Header content is automatically rendered as a child of an h5.
    //Body content is not nested any further than the modal body divs.

    return (
        <>
            <Modal size={size} isOpen={isOpen} toggle={toggle}>
                <ModalHeader className={headerClassName}>
                    {headerContent}
                </ModalHeader>
                <ModalBody className={bodyClassName}>               
                    {bodyContent}
                </ModalBody>
            </Modal>
        </>
    )
}

export default BaseModal;